import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import { DraggableLists } from 'routes/essential-workspace/components/right-panel/draggable-list/draggable-lists';
import { useLayoutPreferences } from 'routes/essential-workspace/components/right-panel/hooks/use-layout-preferences';

type EssentialRightPanelContentProps = {
  currentSectionId: string;
  setCurrentSection: (sectionId: string) => void;
  closePanel: () => void;
};

export function EssentialRightPanelContent({
  currentSectionId,
  setCurrentSection,
  closePanel,
}: EssentialRightPanelContentProps) {
  const {
    sections,
    visibleFields,
    additionalConfigurationFields,
    togglePinForVisibleField,
    updateCustomFields,
    updateFieldWidth,
  } = useLayoutPreferences({ currentSectionId, setCurrentSection, closePanel });

  return (
    <div className="essential-right-panel-content h-100 d-flex flex-column">
      <div className="flex-grow-1 overflow-auto essential-right-panel-scroll-content px-1">
        <div className="mb-4">
          <label htmlFor="essential-section" className="form-label fs-5 fw-normal text-secondary mb-2">
            <FormattedMessage id="essential.workspace.right.panel.section" />
          </label>
          <select
            id="essential-section"
            className="form-select rounded-0 border-secondary-subtle py-2 px-3 fw-medium essential-right-panel-select"
            value={currentSectionId}
            onChange={event => setCurrentSection(event.target.value)}
          >
            {sections.map(section => (
              <option key={section.sectionId} value={section.sectionId}>
                <FormattedMessage id={`form.${section.label}` as IntlKey} />
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <DraggableLists
            visibleFields={visibleFields}
            additionalFields={additionalConfigurationFields}
            onTogglePin={togglePinForVisibleField}
            onUpdateCustomFields={updateCustomFields}
            onUpdateFieldWidth={updateFieldWidth}
          />
        </div>
      </div>
    </div>
  );
}
